export class Login {
  constructor (
    public email: string,
    public password: string,
    public msg: string
  ) {}
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/model/login.ts